"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMPLETE_ORDER_MODAL = void 0;
var COMPLETE_ORDER_MODAL = {
  LABEL__INVOICE_MATCH_ORDER_YES: 'completeOrderModal-label-invoiceMatchOrderYes',
  LABEL__INVOICE_MATCH_ORDER_NO: 'completeOrderModal-label-invoiceMatchOrderNo',
  LABEL__UPLOAD_INVOICES: 'completeOrderModal-label-uploadInvoices',
  LABEL__UPLOAD_IMAGES: 'completeOrderModal-label-uploadImages',
  TEXTAREA__NOTE: 'completeOrderModal-textarea-note',
  BUTTON__WAREHOUSE: 'completeOrderModal-button-warehouse',
  BUTTON__ADVANCED_OPTIONS: 'completeOrderModal-button-advancedOptions',
  BUTTON__CONFIRM: 'completeOrderModal-button-confirm',
  BUTTON__CANCEL: 'completeOrderModal-button-cancel',
  CONTAINER__ADVANCED_OPTIONS_CONTAINER: 'completeOrderModal-div-advancedInventoryManagementContainer',
  TEXT__ADVANCED_OPTIONS_ERROR: 'completeOrderModal-div-advancedInventoryManagementError'
};
exports.COMPLETE_ORDER_MODAL = COMPLETE_ORDER_MODAL;